module.exports = __webpack_public_path__ + "img/PIProductions.8e8a4da.png";